import styled, { css } from 'styled-components';
import { Disableable, getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { BareIconButton } from '../BareIconButton';
import {
    getActiveBackgroundColor,
    getActiveColor,
    getBackgroundColor,
    getColor,
    getHoverBackgroundColor,
    getHoverColor,
} from './getChipStyles';

type ChipContainerProps = Disableable & {
    error?: boolean;
    showRemoveButton?: boolean;
    readOnly?: boolean;
};

export const ChipContainer = styled.div<ChipContainerProps>`
    display: inline-flex;
    padding: ${getSpacingToken('0')}px
        ${({ showRemoveButton, readOnly }) => (showRemoveButton && !readOnly ? 0 : getSpacingToken('100'))}px
        ${getSpacingToken('0')}px ${getSpacingToken('100')}px;
    background-color: ${getBackgroundColor};
    border-radius: ${getToken('borderRadius100')}px;
    align-items: center;
    overflow: hidden;
    cursor: auto;
    min-height: ${getToken('sizing300')}px;

    ${({ showRemoveButton }) =>
        showRemoveButton &&
        css`
            &:hover {
                background-color: ${getHoverBackgroundColor};
            }

            &:active {
                background-color: ${getActiveBackgroundColor};
            }
        `}
`;

interface ChipTextProps extends Disableable {
    error?: boolean;
    readOnly?: boolean;
}

export const ChipText = styled.div<ChipTextProps>`
    ${getTextTokenPreset('bodyMedium')};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${getColor};
    line-height: ${getToken('lineHeight200')};
`;

interface ChipIconButtonProps extends Disableable {
    error?: boolean;
}

export const ChipIconButton = styled(BareIconButton)<ChipIconButtonProps>`
    height: ${getToken('sizing300')}px;
    width: ${getToken('sizing300')}px;
    color: ${getColor};
    &:focus,
    &:focus-visible {
        outline-offset: -${getSpacingToken('25')}px;
        border-radius: ${getToken('borderRadius200')}px;
    }
    &:hover:enabled {
        color: ${getHoverColor};
    }
    &:active:enabled {
        color: ${getActiveColor};
    }
`;
